import { css } from '@emotion/react';

export interface Hacks {}

export function getHacksStyles(hacks: Hacks) {
  // No hacks for now! Look how good we are!
  return css([]);
}
